import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ArticleCard = ({ article }) => {
    // Determine the correct page route based on pageType
    const getPageRoute = () => {
        if (!article.pageType) return 'articles';
        switch (article.pageType.toLowerCase()) {
            case 'news': return 'news';
            case 'research': return 'research';
            case 'info': return 'info';
            default: return 'articles';
        }
    };

    const pageRoute = getPageRoute();

    return (
        <motion.div whileHover={{ y: -5 }} className="card h-full flex flex-col overflow-hidden">
            <Link to={`/articles/${article.slug || article._id}`} className="block relative w-full h-56 overflow-hidden bg-gray-200 dark:bg-gray-800">
                <img 
                    src={article.coverImageUrl} 
                    alt={`${article.title} - ${article.category || 'Aviation'}`}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/800x450/1e40af/ffffff?text=AircoreDynamics';
                        e.target.onerror = null;
                    }}
                />
            </Link>
            <div className="p-6 flex flex-col flex-grow">
                <p className="text-sm font-semibold text-light-primary dark:text-dark-primary mb-2">{article.category || 'Genel'}</p>
                <Link to={`/articles/${article.slug || article._id}`}>
                    <h3 className="text-xl font-bold mb-3 hover:text-light-primary dark:hover:text-dark-primary transition-colors">{article.title}</h3>
                </Link>
                <p className="text-sm opacity-70 mb-4">{article.excerpt}</p>
                
                {/* Tags */}
                {article.tags && article.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-4">
                        {article.tags.map((tag, index) => (
                            <Link 
                                key={index}
                                to={`/${pageRoute}?tag=${encodeURIComponent(tag)}`}
                                className="text-xs px-2 py-1 bg-light-primary/10 dark:bg-dark-primary/10 text-light-primary dark:text-dark-primary rounded-full hover:bg-light-primary/20 dark:hover:bg-dark-primary/20 transition-colors"
                                onClick={(e) => e.stopPropagation()}
                            >
                                #{tag}
                            </Link>
                        ))}
                    </div>
                )}
                
                <div className="flex items-center text-xs opacity-60 mt-auto pt-4 border-t border-light-border dark:border-dark-border">
                    <span>{article.author?.name || 'AircoreDynamics Team'}</span>
                    <span className="mx-2">•</span>
                    <span>{new Date(article.createdAt).toLocaleDateString('tr-TR')}</span>
                    {article.views > 0 && (
                        <>
                            <span className="mx-2">•</span>
                            <span>{article.views.toLocaleString()} views</span>
                        </>
                    )}
                </div>
            </div>
        </motion.div>
    );
};

export default ArticleCard;